import type { TAccountDTO } from "@/store/accounts/accountTypes";
import { isFalsy, isNullable } from "@/utils/guards";

export const runAccountValidation = (
    considerNewAccounts: boolean = false,
    rowData: TAccountDTO[],
    validationErrors: Record<number, Record<string, string>>,
    setValidationErrors: (
        errors: Record<number, Record<string, string>>,
    ) => void,
    setShowValidationErrors: (show: boolean) => void,
) => {
    const errors: Record<number, Record<string, string>> = {};
    const accountNames = rowData.map(acc => acc.account);
    const accountCodes = rowData.map(acc => acc.code);

    let hasErrors = false;

    for (const acc of rowData.filter(
        acc =>
            isFalsy(acc.toBeDeleted) &&
            (considerNewAccounts === true
                ? true
                : !isNullable(validationErrors?.[acc.id])),
    )) {
        let codeErrors: string[] = [];
        let accountErrors: string[] = [];
        if (accountNames.filter(name => name === acc.account).length > 1) {
            accountErrors = [...accountErrors, `Account name must be unique.`];
        }
        if (acc.account === "") {
            accountErrors = [
                ...accountErrors,
                `Account name must not be empty.`,
            ];
        }
        if (accountCodes.filter(code => code === acc.code).length > 1) {
            codeErrors = [...codeErrors, `Account code must be unique.`];
        }
        if (acc.code === "" || acc.code === null) {
            codeErrors = [...codeErrors, `Account code must not be empty.`];
        }
        if (typeof acc.code === "string" && acc.code.includes(" ")) {
            codeErrors = [
                ...codeErrors,
                `Account code must not contain spaces.`,
            ];
        }
        errors[acc.id] = {
            code: codeErrors.join("\n"),
            account: accountErrors.join("\n"),
        };
        if (codeErrors.length > 0 || accountErrors.length > 0) {
            hasErrors = true;
        }
    }
    setValidationErrors(errors);
    if (!hasErrors) {
        setShowValidationErrors(false);
    }
    return hasErrors;
};
